


































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";
import { getBirthday, getTimeAgo } from "@/services/dateTime/date-time-fofmat";
import StandartTable from "@/components/tables/standart-table.vue";
import InputSearch from "@/components/app/search/input-search.vue";

@Component({
  name: "user-administration-list",
  components: { StandartTable, InputSearch },
})
export default class UserAdministrationList extends Vue {
  @Prop({ type: Array, default: [] }) users!: Array<IUser>;
  @Prop({ type: Boolean, default: false }) canChange!: boolean;

  getBirthday(date: string | Date): string {
    return getBirthday(date);
  }

  getDateTime(date: string | Date): string {
    return getTimeAgo(date);
  }

  statusClass(status: string): string {
    switch (status) {
      case "Online":
        return "online";
      case "Warm":
        return "warm";
      case "Offline":
        return "offline";
      default:
        return "unknown";
    }
  }
}
